import { Controller } from '@hotwired/stimulus'
import lottie from 'lottie-web'

export default class extends Controller {
  static values = {
    jsonPath: { type: String },
    loop: { type: Boolean, default: false }
  }

  static targets = ['container']

  connect () {
    this.animation = lottie.loadAnimation({
      container: this.containerTarget,
      renderer: 'svg',
      loop: this.loopValue,
      autoplay: true,
      path: this.jsonPathValue
    })
  }

  disconnect () {
    if (this.animation) {
      this.animation.destroy()
    }
  }
}
